/**
 * Autogenerated file.
 * For adding or changing icons, see README.MD
 */
import React from 'react';
import { createIcon } from '../../icon/create-icon';
// Outline
const ArrowUpRightOutline = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M6 18 18 6m0 0H8.25M18 6v9.75"
})));
// Fill
const ArrowUpRightFill = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M18.75 6v9.75c0 .148-.04.293-.12.416-.09.124-.2.22-.34.278a.758.758 0 0 1-.82-.16l-4.35-4.35-6.59 6.6c-.14.139-.33.216-.53.216s-.39-.077-.53-.216c-.15-.142-.22-.334-.22-.534s.07-.392.22-.534l6.6-6.591-4.35-4.341a.673.673 0 0 1-.2-.389.725.725 0 0 1 .04-.436.707.707 0 0 1 .27-.334.775.775 0 0 1 .42-.125H18a.751.751 0 0 1 .75.75z"
})));
// DuoTone
const ArrowUpRightDuotone = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M6 18 18 6m0 0H8.25M18 6v9.75"
})));
/**
  Icon ArrowUpRightIcon in arrows group
*/
export const ArrowUpRightIcon = createIcon('ArrowUpRightIcon', 'arrow-up-right', 'arrows', ArrowUpRightOutline, ArrowUpRightFill, ArrowUpRightDuotone, "0 0 24 24");